import { createFileRoute } from '@tanstack/react-router';
import { UserForm } from '@/components/users/UserForm.tsx';

export const Route = createFileRoute('/_app/users/create')({
  staticData: { orgScope: 'required' },
  component: () => <UserForm />,
});
